<template>
    <div :class="[width, height, color, colorDark]" class="rounded-md"></div>
</template>

<script>
export default {
    name: 'element-placeholder',

    props: {
        width: {
            type: String,
            default: 'w-5',
        },
        height: {
            type: String,
            default: 'h-5',
        },
        color: {
            type: String,
            default: 'bg-gray-200',
        },
        colorDark: {
            type: String,
            default: 'dark:bg-gray-600',
        },
    },
};
</script>
